import React from "react";
import classes from "./AccessDeniedPage.module.scss";

const AccessDeniedPage = () => {
  return <div className={classes.accessDenied}>Access Denied</div>;
};

export default AccessDeniedPage;
